import React from 'react';
import './Profile.css';

const Greeting = () => (
    <main>
            <div className="row py-lg-5">
                <div className="col-lg-9 col-md-8 mx-auto">
                    <h1 className="fw-light">{'<'} Hello, I'm Charlotte. 👩🏽‍💻 /{'>'}</h1> <br/>
                    <p className="lead text-body-secondary">
    A full-stack developer from Belfast, Northern Ireland. <br/> 
   <br/>
    Enjoy browsing my page where you'll find details about my projects, learn more about me, and discover my skillset. Be sure to reach out — I look forward to connecting with you!                    </p>

      
                    <p>
                        <a href="/Charlotte McKnight full stack dev 2024.pdf" className="btn btn-primary my-2">View my CV</a>
                    </p>
                </div>
            </div>
    </main>
);

export default Greeting;